import countdown from "../countdown"
import primer from "../primer"

export default (getView) => (nextStepPath, timeoutSeconds, externalCheckoutPath) => ({
  ...getView(nextStepPath),
  ...countdown(timeoutSeconds),
  ...primer(),

  statusToTrack: "VISIT_CHECKOUT",

  onInit() {
    const externalCheckout = pipelineConfig.variant.includes("External-Checkout")

    this.initCountdown()

    if (!externalCheckout) {
      this.addConfirmationEventListener()
      this.initPrimer({
        checkoutCompletePath: nextStepPath,
      })
    }
  },

  goToExternalPaymode(hideApm = false) {
    this.store.values.hideApm = hideApm
    window.location = this.store.addTokenHashParam(externalCheckoutPath)
  },
})
